import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    showLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { showLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
